import React from "react";
import "./myofficehours.css";
import { Row, Col } from "react-bootstrap";

const WeeklyHours = (props) => {
	return (
		<>
			{props && (
				<Row className="weekly-hours">
					<Col className="last-week-hours">
						<h6>Last Week Hours</h6>
						{props.lastweekHours && (
							<div className="last-week">
								{props.lastweekHours != "NaN:NaN"
									? props.lastweekHours
									: 0}
							</div>
						)}
					</Col>
					<Col className="current-week-hours">
						<h6>Current Week Hours</h6>
						{props.currentWeekHours && (
							<div className="curr-week">
								{props.currentWeekHours != "NaN:NaN"
									? props.currentWeekHours
									: 0}
							</div>
						)}
					</Col>
					{props.totalhours != null ? (
						<Col className="total-hours">
							<h6>Total Hours</h6>
							{props.totalhours && (
								<div className="curr-month">
									{props.totalhours}
								</div>
							)}
						</Col>
					) : null}
				</Row>
			)}
		</>
	);
};

export default WeeklyHours;
